import { useEffect, useRef, useState } from 'react';

/**
 * Triggers `inView=true` once when the element enters the viewport.
 * Use to gate scroll-in animations.
 */
export const useInView = (threshold = 0.15, rootMargin = '0px') => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return [ref, inView];
};
